export default "__VITE_ASSET__BKq4KJvV__"